import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { AuthAccountState } from './auth-account.state';
import { AuthAccountStore } from './auth-account.store';

@Injectable({providedIn: 'root'})
export class AuthAccountQuery extends QueryEntity<AuthAccountState> {
  constructor(protected readonly store: AuthAccountStore) {
    super(store);
  }
}
